module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-20.68a16048.png";